import { Navigate } from "react-router-dom";
import { useAuth } from "../../hooks";

const PublicRoutes = ({ children }) => {
  const isAuth = useAuth();
  return <>{isAuth ? <Navigate to="/" /> : children}</>;
};

export default PublicRoutes;
